import _ from 'lodash';

var newestToOldest = function newestToOldest(a, b) {
  if (a.lastUpdated === b.lastUpdated) return 0;
  return a.lastUpdated > b.lastUpdated ? -1 : 1;
};

var getLastUpdatedManualScore = function getLastUpdatedManualScore() {
  var manualScores = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return _.first(manualScores.sort(newestToOldest));
};

export default {
  getLastUpdatedManualScore: getLastUpdatedManualScore
};